import FunctionalityListService from "@/services/FunctionalityListService";
import _ from 'lodash';

const SPECIAL_FUNCTIONALITY = [
    {
        id: 'search',
        parentId: 'search'
    },
    {
        id: 'synonym',
        parentId: 'search'
    },
    {
        id: 'redirect',
        parentId: 'search'
    },
    {
        id: 'content',
        parentId: 'search'
    },
    {
        id: 'ab-testing',
        parentId: 'search'
    },
    {
        id: 'searchlab',
        parentId: 'search'
    },
    {
        id: 'query-rule',
        parentId: 'search'
    },
    {
        id: 'dependency',
        parentId: 'search'
    },
    {
        id: 'curator',
        parentId: 'search'
    },
    {
        id: 'analyzer',
        parentId: 'index-storage'
    },
    {
        id: 'vectorizer',
        parentId: 'index-storage'
    },
    {
        id: 'index-storage',
        parentId: 'index-storage'
    },
    {
        id: 'monitoring',
        parentId: 'monitoring'
    },
    {
        id: 'web-monitoring',
        parentId: 'monitoring'
    },
    {
        id: 'system-monitoring',
        parentId: 'monitoring'
    },
];
const FUNCTIONALITY_LIST = FunctionalityListService()

export default {
    mapDependencyUrl(data) {
        for (let i = 0; i < data.length; i++) {
            const functionalityList = Object.keys(data[i]);

            functionalityList.map((key) => {
                const id = data[i][key].url.split('/')[1];

                if (!id) {
                    return data;
                }

                const specialFunctionality = this.returnSpecialFunctionality(id);

                if (specialFunctionality) {
                    data[i][key].url = this.mapUrl({
                        id: id,
                        tenant: data[i][key].tenant,
                        code: data[i][key].code,
                        parentId: specialFunctionality.parentId
                    });
                }
            })

        }
        return data;
    },
    mapOptionsUrl(data) {
        for (let i = 0; i < data.length; i++) {
            const code = data[i].code;
            const tenant = data[i].tenant;
            const id = data[i].url.split('/')[1];

            if (!id) {
                return data;
            }

            const specialFunctionality = this.returnSpecialFunctionality(id);

            if (specialFunctionality) {
                data[i].url = this.mapUrl({
                    id: id,
                    tenant: tenant,
                    code: code,
                    parentId: specialFunctionality.parentId
                })
            }
        }

        return data;
    },
    mapUrl({id, tenant, code, parentId}) {
        const parentFunctionality = _.find(FUNCTIONALITY_LIST, {
            parentId: parentId
        });

        if (!parentFunctionality) {
            return;
        }

        const childFunctionality = _.find(parentFunctionality.items, {
            id: id
        });

        if (!childFunctionality) {
            return;
        }

        return `${childFunctionality.baseUrl}/${tenant}/${code}`;
    },
    returnSpecialFunctionality(id) {
        return _.find(SPECIAL_FUNCTIONALITY, {
            id: id
        });
    },
    mapIndexCodeOptions(indexCodeOptions, tenant) {
        for (let i = 0; i < indexCodeOptions.length; i++) {
            indexCodeOptions[i]['url'] = `/index/index-storage/${tenant}/${indexCodeOptions[i].code}`
        }

        return indexCodeOptions;
    },
    mapStringArrayToObjectArray(stringArray, key) {
        const objectArray = [];

        stringArray.map(v => {
            objectArray.push({
                [key]: v
            })
        })

        return objectArray;
    },
    mapObjectArrayToStringArray(objectArray, key) {
        const stringArray = [];

        objectArray.map(v => {
            stringArray.push(v[key]);
        });

        return stringArray;
    },
    mapDataLinks(dataLinks) {
        const mappedLinks = [];

        for (let i = 0; i < dataLinks.length; i++) {
            mappedLinks.push({
                title: dataLinks[i].name,
                status: true,
                icon: 'fa fa-external-link',
                clickMethod: (() => {
                    window.open(dataLinks[i].code, '_blank').focus();
                })
            });
        }

        return mappedLinks;
    },
    mapSearchFiltersToUseInQscEditTable(filters) {
        if (!filters || filters.length <= 0) {
            return filters;
        }

        for (let i = 0; i < filters.length; i++) {
            if (!filters[i].values) {
                return;
            }

            filters[i].values = filters[i].values.length > 0 ? filters[i].values.reduce((a, b) => a + "," + b) : [];
        }

        return filters;
    },
    mapSearchFiltersToUseInAPI(filters) {
        if (filters.length <= 0) {
            return filters;
        }

        for (let i = 0; i < filters.length; i++) {
            filters[i].values = filters[i].values.length > 0 ? filters[i].values.split(',').map((val) => val.trim()) : [];
        }

        return filters;
    },
    mapTabFormFieldsRowsToDocumentFields(rows) {
        const fields = {};

        rows.map(row => {
            if (!row.code) {
                return;
            }

            const code = row['code'];
            delete row['code'];

            fields[code] = {
                ...row
            };
        })

        return fields;
    }
}
